import React, { useState } from "react";
import styled from "styled-components";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <HeaderContainer>
      <HeaderContent>
        <Logo>Tersa Construction</Logo>
        <Nav>
          <NavLinks isMobileMenuOpen={isMobileMenuOpen}>
            <NavLink href="/">Home</NavLink>
            <NavLink href="/#about">About</NavLink>
            <NavLink href="/#team">Team</NavLink>
            <NavLink href="/#services">Services</NavLink>
            <NavLink href="/#projects">Projects</NavLink>
            <NavLink href="/gallery">Gallery</NavLink>
            <NavLink href="/#contact">Contact Us</NavLink>
          </NavLinks>
          <MobileMenuButton onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? "✕" : "☰"}
          </MobileMenuButton>
        </Nav>
      </HeaderContent>
    </HeaderContainer>
  );
};

// Styled Components
const HeaderContainer = styled.header`
  background-color: #003366;
  color: #f3f6fb;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 30px 0;
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%; /* Restrict width to 80% */
  margin: auto; /* Center the content */
`;

const Logo = styled.div`
  font-size: 2rem; /* Default size for larger screens */
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 2px;

  @media (max-width: 768px) {
    font-size: 1.5rem; /* Medium screens */
  }

  @media (max-width: 480px) {
    font-size: 1.2rem; /* Small screens */
  }
`;


const Nav = styled.nav`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-end;
    width: 100%;
  }
`;

const NavLinks = styled.div<{ isMobileMenuOpen: boolean }>`
  display: flex;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    display: ${({ isMobileMenuOpen }) => (isMobileMenuOpen ? "flex" : "none")};
    background-color: #003366;
    padding: 20px;
    position: fixed; /* Fix the menu to the screen */
    top: 0;
    left: 0;
    height: 100%; /* Full height for mobile menu */
    width: 100%; /* Full width for mobile menu */
    overflow-y: auto; /* Allow scrolling if menu items overflow */
    z-index: 999; /* Ensure it stays above other elements */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
`;

const NavLink = styled.a`
  text-decoration: none;
  color: #f3f6fb;
  font-size: 1.2rem; /* Slightly larger font for better readability on mobile */
  transition: color 0.3s;

  &:hover {
    color: #ffa500; /* Accent color for hover state */
  }
`;

const MobileMenuButton = styled.button`
  background: none;
  border: none;
  color: #f3f6fb;
  font-size: 1.5rem;
  cursor: pointer;
  position: absolute; /* Fix the button's position */
  top: 20px;
  right: 20px; /* Ensure it's visible within the screen */
  z-index: 1000;

  @media (max-width: 768px) {
    display: block;
  }
`;

export default Header;
